// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v0.0.0',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://toothteller-controller-api-dev.azurewebsites.net/api',
  paymentApiUrl: 'https://toothteller-payments-api.azurewebsites.net/api',
  tenantApiUrl: 'https://toothteller-tenant-api.azurewebsites.net/api',
  tenantNotificationHubUrl:
    'https://toothteller-tenant-api.azurewebsites.net/notificationHub',
  clearentPaymentGatewayBaseUrl: 'https://gateway-int.clearent.net',
  installationFilesBaseUrl:
    'https://stgtoothtellerardev.blob.core.windows.net/installationfiles',
  recaptchaSiteKey:'6LfDS5osAAAAAGA6GDrXCep0NZIG3Q_C70SnOrV7'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
